import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Are you sure?',
    message:
      'If you cancel this withdraw, it cannot be restored.<br/>You will need to start over again.',
    confirm: 'Cancel withdrawal',
    cancel: 'Continue withdrawing',
  },
};
